import { SortOrder } from "../sort-order";

export class EncoderFilters {
  name: string;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
